import React from "react";
import ContentListGrid from "../components/ContentListGrid";
import PublicPageSettings from "../components/PublicPageSettings";
import CareersGlobalSettings from "../components/CareersGlobalSettings";
import { COLLECTIONS } from "../utils/cmsSchema";

// CMS home for /careers. Layered top-down:
//   1. PublicPageSettings — hero heading/subheading, hero image, and
//      page-level SEO (metaTitle/metaDescription) for /careers.
//   2. CareersGlobalSettings — the global "apply email" default used
//      when a job doesn't override it. Small dedicated card because
//      it doesn't fit PublicPageSettings' schema.
//   3. ContentListGrid — the actual list of job postings, with
//      create/publish/delete plumbing shared with blogs/news.
export default function CareersList() {
  return (
    <div>
      <PublicPageSettings
        collectionKey="careers"
        publicPath="/careers"
        defaultHeading="Join our team"
        defaultSubheading="Build your career with the Philippines' leading real estate advisory firm. Explore open roles below."
      />
      <CareersGlobalSettings />
      <ContentListGrid
        schema={COLLECTIONS.careers}
        title="Job Postings"
        subtitle="Roles shown on /careers. Each also gets its own /careers/<slug> page for share links and Google Jobs."
        newRoute="/cms/careers/new"
        metaFor={(d) =>
          [d.department, d.location, d.employmentType]
            .filter(Boolean)
            .join(" · ")
        }
      />
    </div>
  );
}
